// ✅ FILE: src/components/corporate-governance.js

import React from 'react';
import "./terms-conditions.css";
// import './corporate-governance.css'; // Optional: Use if you have specific styles

const CorporateGovernance = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-4">
        <h1>Corporate Governance Policy</h1>
        <p className="text-muted">Guidelines for Ethical and Transparent Management</p>
      </header>

      <section className="tc-content mb-3">
        <h2>1. Preamble</h2>
        <p>
          <b>Singh Finlease Private Limited</b> believes that sound corporate governance practices are critical for the functioning of the Company and for creating a trustworthy, transparent, moral, and ethical environment, both internally and externally. The Company ensures good governance through the implementation of effective policies and procedures, mandated and regularly reviewed by the Board of Directors (“Board”) or by the Committees duly constituted by the Board.
        </p>
        <p> 
          The Reserve Bank of India (“RBI”) via Master Direction – Reserve Bank of India (Non-Banking Financial Company – Scale Based Regulation) Directions, 2023, requires all NBFCs to frame internal guidelines on corporate governance. Accordingly, the Company has framed this policy.
        </p>

        <h2>2. Purpose</h2>
        <p>
          The purpose of this policy is to enable the adoption of best practices and greater transparency in the operations of the Company. The affairs of the Company shall be conducted with integrity, fairness, accountability, and transparency to create value for stakeholders, including shareholders, employees, and customers.
        </p>

        <h2>3. Definitions</h2>
        <ul className="definition-list">
          <li className="mb-2">
            <b>Applicable Laws:</b> Refers to the rules, regulations, and RBI Master Directions applicable to the Company, including the Companies Act, 2013.
          </li>
          <li className="mb-2">
            <b>Board:</b> The Board of Directors of Singh Finlease Private Limited.
          </li>
          <li className="mb-2">
            <b>Committee:</b> Committees duly constituted by the Board to perform specific functions delegated by the Board for effective management.
          </li>
          <li className="mb-2">
            <b>Senior Management:</b> Personnel who are members of the core management team, excluding the Board, comprising members one level below the executive directors.
          </li>
        </ul>

        <h2>4. Internal Guidelines</h2>

        <div className="governance-sub-section">
          <h5><b>A. Board of Directors</b></h5>
          <p>
            <strong>Constitution:</strong> The Board shall consist of a minimum of two (02) directors. The Board shall have an optimum combination of executive and non-executive directors in line with applicable laws and the Articles of Association.
          </p>
          <p>
            <strong>Meetings:</strong> At least four meetings of the Board shall be held in a year, with a maximum gap of 120 days between any two consecutive meetings.
          </p>
          <p>
            <strong>Quorum:</strong> The quorum shall be one-third of the total strength of the Board or two directors, whichever is higher. Participation via video conferencing is permitted as per Applicable Laws.
          </p>

          <h5 className="mt-4"><b>B. Constitution of Committees</b></h5>
          <p>The Board has implemented a structured approach by forming specialized Committees to ensure accountability:</p>
          <div className="row mt-2">
            <div className="col-md-6">
              <ul>
                <li>Audit Committee (ACM)</li>
                <li>Nomination and Remuneration Committee (NRC)</li>
                <li>Asset Liability Management Committee (ALMC)</li>
                <li>Risk Management Committee (RMC)</li>
              </ul>
            </div>
            <div className="col-md-6">
              <ul>
                <li>IT Strategy Committee (ITSC)</li>
                <li>Corporate Social Responsibility Committee (CSRC)</li>
                <li>Loan, Investment and Borrowing Committee (LIBC)</li>
                <li>Stakeholders Relationship Committee (SRC)</li>
              </ul>
            </div>
          </div>

          <h5 className="mt-4"><b>C. Key Appointments</b></h5>
          <ul>
            <li><strong>Chief Risk Officer (CRO):</strong> Appointed as per RBI Master Directions to manage and mitigate organizational risks.</li>
            <li><strong>Chief Compliance Officer (CCO):</strong> Responsible for ensuring the Company adheres to all regulatory and statutory requirements.</li>
            <li><strong>Head of Internal Audit (HIA):</strong> Appointed to maintain independence and objectivity in the internal audit process.</li>
          </ul>

          <h5 className="mt-4"><b>D. Fit and Proper Criteria</b></h5>
          <p>
            The Company maintains a 'Fit and Proper' policy for the appointment of Directors. Necessary disclosures and declarations are obtained at the time of appointment and on a continuing basis to ensure the integrity of the Board.
          </p>

          <h5 className="mt-4"><b>E. Disclosure and Transparency</b></h5>
          <p>
            The Company shall comply with all disclosure requirements in financial statements as mandated by the RBI and the Companies Act. This includes disclosing related party transactions and any non-compliance incidents.
          </p>
        </div>

        <h2 className="mt-5">5. Review of Policy</h2>
        <p>
          This Policy shall be reviewed by the Board on an annual basis to ensure it remains aligned with any amendments in Applicable Laws or changes in the Company's operational position. In case of any contradiction between this policy and statutory legislation, the provisions of the law shall prevail.
        </p>
      </section>
    </div>
  );
};

export default CorporateGovernance;